"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Journal {
    constructor(adapter, cache) {
        this.getLifeJournalEntry = async (customerId, date) => {
            return this.adapter.getLifeJournalEntry(customerId, date);
        };
        this.getMindJournalEntry = async (customerId, date) => {
            return this.adapter.getMindJournalEntry(customerId, date);
        };
        this.adapter = adapter;
        this.cache = cache;
    }
    getJournalWeeklyEntries(domain, customerId, startDate, endDate) {
        return (domain === "life"
            ? this.adapter.getLifeWeeklyEntries(customerId, startDate, endDate)
            : this.adapter.getMindWeeklyEntries(customerId, startDate, endDate));
    }
}
exports.default = Journal;
//# sourceMappingURL=Journal.js.map